import React, { useMemo, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../components/buttons/buttons";
import Table from "../../../components/tables/tableCols1";
import TableSkeleton from "../../../components/skeleton/table";
import TableFilter from "../../../components/tables/tableFilter";
import { numberWithCommas } from "../../../components/helpers";
import { PaginationNoRoute } from "../../../components/pagination/paginationNoRoute";
import Merchandise from "../../../assets/images/icons/merchandiseEmpty.svg";
import {
  filterMerchandises,
  searchAllMerchandises,
} from "../../../redux/merchandise/merchandiseActions";
import { writeFileWithXLSX } from "../../../components/exports/xlsx";
import { AllFiltersModal } from "../../../components/modals/allFiltersModal";
import FilterMerchandise from "../../../components/dropDown/filter/merchandiseFilter";
import merchandiseType from "../../../redux/merchandise/merchandiseTypes";

export default function AllMerchandise() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let { id } = useParams();
  const { allMerchandises, filtering, searching, filterNoPage } = useSelector(
    (state) => state.merchandise
  );

  const [isFilterOpen, setFilterState] = useState(false);
  const [payLoad] = useState({
    store_id: id,
    end_date: new Date(),
  });

  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [input, setInput] = useState({
    search: "",
  });

  useEffect(() => {
    if (id) {
      dispatch(filterMerchandises({ ...payLoad, store_id: id }, page));
    }

    // eslint-disable-next-line
  }, [id]);

  function createTableData(data) {
    let dataToMap = data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap?.map((merchandise, index) => {
        let single = {
          num: <span className="text-base font-semibold">{index + 1}</span>,
          name: merchandise?.merchandise_name,
          price: (
            <span>NGN {numberWithCommas(merchandise?.merchandise_amount)}</span>
          ),
          discount: (
            <span>
              NGN {numberWithCommas(merchandise?.merchandise_discount)}
            </span>
          ),
          availability:
            merchandise?.merchandise_operating_status === "available" ? (
              <span className="text-green-400">Available</span>
            ) : (
              <span className="text-red-600">Unavailable</span>
            ),
          status: merchandise?.management_approved ? (
            <span className="text-green-400">Approved</span>
          ) : (
            <span className="text-red-600">Unapproved</span>
          ),

          merchandise: merchandise,
        };

        outputArray.push({ single });
        return true;
      });
      return outputArray;
    }
  }

  useEffect(() => {
    const dataSet = createTableData(allMerchandises?.data);
    setData(dataSet);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allMerchandises]);

  function createTableNoPage(data) {
    let dataToMap = data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap?.map((merchandise, index) => {
        let single = {
          num: <span className="text-base font-semibold">{index + 1}</span>,
          name: merchandise?.merchandise_name,
          price: merchandise?.merchandise_amount,
          discount: merchandise?.merchandise_discount,
          status:
            merchandise?.merchandise_operating_status === "available"
              ? "available"
              : "unavailable",
          availability: merchandise?.merchandise_operating_status,
        };

        outputArray.push(single);
        return true;
      });
      return outputArray;
    }
  }

  const downloadCSV = () => {
    if (filterNoPage) {
      const newData = createTableNoPage(filterNoPage);
      writeFileWithXLSX(newData, {
        filename: "All Merchandises.xlsx",
        download: true,
      });
    }
  };

  function goToSinglePage(params) {
    let merchandise_id = params?.single?.merchandise?.id;
    navigate(`/admin/merchandise/${merchandise_id}`, {
      state: { merchandise: params?.single?.merchandise },
    });
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    e.preventDefault();
    setInput({ ...input, [name]: value });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      doSearch();
    }
  };

  const showSearch = (search) => {
    let dataSet = createTableData(search);
    setData(dataSet);
  };

  const removeSearch = () => {
    if (input?.search?.length === 0) {
      let dataSet = createTableData(allMerchandises?.data);
      setData(dataSet);
      dispatch({
        type: merchandiseType["SEARCH_MERCHANDISE"],
        payLoad: { data: [] },
      });
    }
  };

  async function doSearch() {
    try {
      let response = await dispatch(searchAllMerchandises(input));
      if (response?.status === "success") {
        showSearch(response?.data);
      }
      if (!response?.status) {
        showSearch([]);
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (input?.search?.length === 0) {
      removeSearch();
    }
    // eslint-disable-next-line
  }, [input, dispatch]);

  const columns = useMemo(
    () => [
      {
        Header: "",
        hideHeader: false,
        id: "checkbox-table-column",
        // First group columns
        columns: [
          {
            Header: "SN",
            accessor: "single.num",
          },

          {
            Header: "Merchandise Name",
            accessor: "single.name",
          },
          {
            Header: "Amount",
            accessor: "single.price",
          },
          {
            Header: "Discount",
            accessor: "single.discount",
          },
          {
            Header: "Availability Status",
            accessor: "single.availability",
          },
          {
            Header: "Approval Status",
            accessor: "single.status",
          },
        ],
      },
    ],
    []
  );
  return (
    <>
      <TableFilter
        title={"Merchandise"}
        results={allMerchandises?.to}
        totalResults={allMerchandises?.total}
        onChange={handleChange}
        handleKeyDown={handleKeyDown}
        page={page}
        payLoad={payLoad}
        filter={
          <AllFiltersModal
            isFilterOpen={isFilterOpen}
            setFilterState={setFilterState}
          >
            <FilterMerchandise
              isFilterOpen={isFilterOpen}
              setFilterState={setFilterState}
              payLoad={payLoad}
            />
          </AllFiltersModal>
        }
        searchPlaceholder={" Merchandise Name"}
      >
        <Button.Secondary
          title={"Download CSV"}
          onClick={() => downloadCSV()}
          disabled={!data}
        />
      </TableFilter>

      <div className="border-b border-[#E4E4F3] dark:border-[#505050]"></div>

      <div className="bg-white dark:bg-[#121212] rounded-md py-4">
        {filtering || searching ? (
          <TableSkeleton />
        ) : data?.length > 0 ? (
          <Table
            columns={columns}
            data={data?.length > 0 ? data : []}
            onClick={goToSinglePage}
            className="w-full"
            rowClass="hover:shadow-md cursor-pointer"
          />
        ) : (
          <div className="text-center">
            {" "}
            <div className="flex justify-center my-12 ">
              <img src={Merchandise} alt="merchandise" />
            </div>
            <p className="font-bold text-xl my-3">Merchandise</p>
            <p className="text-sm text-gray-500">
              You have no Merchandise yet.
            </p>
          </div>
        )}

        <PaginationNoRoute
          data={allMerchandises}
          page={page}
          setPage={setPage}
        />
      </div>
    </>
  );
}
